module.exports = __webpack_public_path__ + "static/img/picc-icon3.4221320.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/picc-icon3.png
// module id = 4irk
// module chunks = 1